const TMP_VECTORS = new Array(8).fill(1).map(() => new THREE.Vector3());
const KEYS = [
    [["min", "x"], ["min", "y"], ["min", "z"]],
    [["min", "x"], ["min", "y"], ["max", "z"]],
    [["min", "x"], ["max", "y"], ["min", "z"]],
    [["max", "x"], ["min", "y"], ["min", "z"]],
    [["min", "x"], ["max", "y"], ["max", "z"]],
    [["max", "x"], ["min", "y"], ["max", "z"]],
    [["max", "x"], ["max", "y"], ["min", "z"]],
    [["max", "x"], ["max", "y"], ["max", "z"]],
];

/**
 * 
 * @param {THREE.Box3} box 
 * @param {THREE.Camera} camera 
 * @returns {THREE.Box2}
 */
function calcScreenspaceBoundingbox(box, camera, out = new THREE.Box2) {
    return TMP_VECTORS
        .map((v, i) => {
            const keys = KEYS[i];

            v
                .set(
                    ...keys.map(([sz, ax]) => box[sz][ax])
                )
                .project(camera);

            return Q3.RenderManager.toScreenCoords(v.x, v.y);
        }).reduce((box, v) => {
            box.min.x = Math.min(box.min.x, v.x);
            box.max.x = Math.max(box.max.x, v.x);
            box.min.y = Math.min(box.min.y, v.y);
            box.max.y = Math.max(box.max.y, v.y);

            return box;
        }, out.makeEmpty());
}

export default calcScreenspaceBoundingbox;
export { calcScreenspaceBoundingbox };